import { useSelector } from 'react-redux';
import { selectUser } from '../../slices/auth';
import { useNavigate } from 'react-router';
import { UserRoles } from '../../utils/constants';
import { NavLink } from 'react-router-dom';
import { BsFillTrashFill } from 'react-icons/bs';

type TeamCardProps = {
  team: {
    id: number;
    teamName: string;
    season: any[];
    activeMembers: any[];
    User: any[];
    Game: {
      active_limit: number;
    };
    School: {
      image: string;
    };
    game_id: number;
  };
};

const TeamCard = ({ team }: TeamCardProps) => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const seasonName = team.season[0]?.name;
  const isFullMembers = team.activeMembers.length >= team.Game.active_limit;
  const numPlayersWithInGameName = team.User.filter((player: any) =>
    player.InGameName.some((name: any) => name.game_id === team.game_id),
  ).length;
  const isFullInGameNames = numPlayersWithInGameName >= team.activeMembers.length;
  const isTeamFlagged = !seasonName || !isFullMembers || !isFullInGameNames;

  return (
    <div
      className={`border ${
        isTeamFlagged ? 'border-2 border-fen-red' : ''
      } rounded-lg p-4 bg-gray-100 shadow-md`}
    >
      {/* Team Name */}
      <h3
        className='w-fit px-2 mb-2 text-lg font-medium cursor-pointer bg-gray-300 rounded hover:bg-gray-500 hover:text-white'
        onClick={() => navigate(`/teams/view/${team.id}`)}
      >
        {team.teamName}
      </h3>
      {/* Note Section */}
      <p
        className={`text-sm ${
          team.season[0]?.name
            ? 'text-gray-600'
            : `text-fen-red ${
                user.roles === UserRoles.Ogma
                  ? 'cursor-pointer bg-gray-300 rounded hover:bg-gray-500 hover:text-white w-fit px-2'
                  : ''
              }`
        }`}
        onClick={() => {
          if (!team.season[0]?.name && user.roles === UserRoles.Ogma) {
            navigate(`${team.id}/add-to-season`);
          }
        }}
      >
        {team.season[0]?.name ? `Season: ${team.season[0]?.name}` : 'Not In a Season'}
      </p>
      <p className={`text-sm ${isFullMembers ? 'text-gray-600' : 'text-fen-red'} `}>
        Starters: {team.activeMembers.length}/{team.Game.active_limit}
      </p>
      <p className={`text-sm ${isFullInGameNames ? 'text-gray-600' : 'text-fen-red'} `}>
        Members With In Game Name: {numPlayersWithInGameName}/{team.activeMembers.length}
      </p>
      {/* Players Section */}
      <div className='my-3'>
        {team.User?.length ? (
          team.User.map((player: any) => (
            <div
              key={`p-${player.id}`}
              className='flex items-center justify-between bg-white p-2 rounded-md mb-2 shadow-sm'
            >
              <div className='flex items-center gap-2'>
                <span className='bg-gray-300 rounded-full w-8 h-8 flex items-center justify-center'>
                  {team.School?.image ? (
                    <img
                      src={team.School?.image}
                      alt={`${player.firstName} ${player.lastName}`}
                      className='w-8 h-8 rounded-full object-cover'
                    />
                  ) : (
                    <i className='fas fa-user'></i>
                  )}
                </span>
                <div>
                  <p className='text-sm font-medium'>
                    {player.InGameName.find((n: { game_id: any }) => n.game_id === team.game_id)
                      ?.in_game_name || 'No in game name'}
                  </p>
                  <p className='text-xs text-gray-500'>
                    {player.firstName + ' ' + player.lastName}
                  </p>
                </div>
              </div>
              {user.roles === UserRoles.Ogma && (
                <NavLink
                  to={`./${team.id}/remove/${player.id}`}
                  className=' p-2 rounded hover:text-red-500 hover:bg-gray-500'
                >
                  <BsFillTrashFill />
                </NavLink>
              )}
            </div>
          ))
        ) : (
          <p className='text-sm text-gray-500'>No players added.</p>
        )}
      </div>
      {/* Add User Button */}
      {user.roles === UserRoles.Ogma && (
        <NavLink
          to={`./${team.id}/add`}
          className='bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600'
        >
          + Add User
        </NavLink>
      )}
    </div>
  );
};

export default TeamCard;
